import { Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/_services/app.service';

@Component({
  selector: 'app-star',
  templateUrl: './star.component.html',
  styleUrls: ['./star.component.scss']
})
export class StarComponent implements OnInit {

  @Input() element: any;

  constructor(
    private spinner: NgxSpinnerService,
    private service: AppService
  ) { }

  ngOnInit(): void {
  }

  fav(el, bool) {
    this.spinner.show();
    this.service.postService({ documentid: el.documentId, isfavourite: bool, ipaddress: '' }, 'Document/DocumentIsFavourite').subscribe(res => {
      this.spinner.hide();
      if (res.body.success) {
        $('#table1').DataTable().ajax.reload();
        this.service.alertPopup('success', res.body.result.transactionMessage.message);
      } else {
        this.service.alertPopup('delete', res.body.result.transactionMessage.message);
      }
    })
  }

}
